import { useMemo } from 'react'
import { findCheapestOfTourV2Offer } from 'lib/tours/tourUtils'

type CheapestOfTourV2Offer = ReturnType<typeof findCheapestOfTourV2Offer>

function useCheapestOfTourV2Offer(
  offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary,
  selectedVariationId?: App.Tours.TourV2OfferVariation['id'],
): CheapestOfTourV2Offer
function useCheapestOfTourV2Offer(
  offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary | undefined,
  selectedVariationId?: App.Tours.TourV2OfferVariation['id'],
): CheapestOfTourV2Offer | undefined
function useCheapestOfTourV2Offer(
  offer: App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary | undefined,
  selectedVariationId?: App.Tours.TourV2OfferVariation['id'],
): CheapestOfTourV2Offer | undefined {
  return useMemo(() =>
    offer ?
        findCheapestOfTourV2Offer(offer, selectedVariationId, false) :
      undefined,
  [offer, selectedVariationId])
}

export default useCheapestOfTourV2Offer
